import * as React from "react";
import { BorderedGameActionButton } from "src/components/Header/Navbars/InGameNav/InGameNavDropdown/InGameNavDropdown.components";
import {
  NavList,
  StyledNav,
} from "src/components/Header/Navbars/NavbarsSharedComponents";
import { displaySuccessToast } from "src/components/shared/Toasts/Toast";
import { ToastIds } from "src/enums/errorToastIds";
import { ReactComponent as AngleRight } from "src/images/angleRight.svg";
import { useModal } from "src/components/shared/Modal";
import GameSummaryModal from "src/components/Header/Navbars/InGameNav/GameSummaryModal";
import {
  NavButton,
  NavLink,
} from "src/components/Header/Navbars/InGameNav/InGameNav.components";

export interface Props {
  closeNav: () => void;
  openContactModal: () => void;
}

const InGameNav: React.FunctionComponent<Props> = ({
  closeNav,
  openContactModal,
}) => {
  const { openFixedModal, closeModal } = useModal();

  const openGameModal = React.useCallback(() => {
    openFixedModal(<GameSummaryModal onGameEnd={closeModal} />);
  }, [openFixedModal]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(
      window.location.toString().replace("game", "join-game")
    );
    displaySuccessToast(
      "Join link copied into your clipboard!",
      ToastIds.LINK_COPIED
    );
  };

  return (
    <StyledNav>
      <NavList>
        <NavLink to="/create-game" onClick={closeNav}>
          Start new game
          <AngleRight />
        </NavLink>
        <NavButton onClick={openContactModal}>
          Contact Us
          <AngleRight />
        </NavButton>
        <BorderedGameActionButton
          themeColor="background"
          onClick={() => {
            closeNav();
            openGameModal();
          }}>
          Show summary
        </BorderedGameActionButton>
        <BorderedGameActionButton
          themeColor="buttonPrimary"
          onClick={handleCopyLink}>
          Invite players
        </BorderedGameActionButton>
      </NavList>
    </StyledNav>
  );
};

export default InGameNav;
